import { ReactElement, useEffect } from 'react'
import { ArrowsDirectional } from '@scene'
import { useControlStore, useStructuralPlanningStore } from '@editorStores'
import WindLoadCPEAreasMesh from 'src/components/scene/WindLoadCPEAreasMesh'
import useGlobalLoadsQueryParams from '../../../../hooks/useGlobalLoadsQueryParams'

const WindloadsScene = (): ReactElement => {
  const setWindLoadDirection = useStructuralPlanningStore(state => state.setWindLoadDirection)
  const changeVisibility = useControlStore(state => state.changeStructuralPlanningElementVisibility)

  const {
    params: { activeRoofAssignmentTab },
  } = useGlobalLoadsQueryParams()

  useEffect(() => {
    if (activeRoofAssignmentTab === '0') {
      setWindLoadDirection('Direction0')
    } else if (activeRoofAssignmentTab === '90') {
      setWindLoadDirection('Direction90')
    } else if (activeRoofAssignmentTab === '180') {
      setWindLoadDirection('Direction180')
    } else if (activeRoofAssignmentTab === '270') {
      setWindLoadDirection('Direction270')
    }
  }, [setWindLoadDirection, activeRoofAssignmentTab])

  useEffect(() => {
    changeVisibility('windLoadZones', true)
    changeVisibility('horizontalWindLoads', true)
  }, [changeVisibility])

  const storey = useControlStore(state => state.floorplanState.storey)
  const showFloorplan = storey !== null

  return (
    <>
      <group visible={!showFloorplan}>
        {activeRoofAssignmentTab && (
          <ArrowsDirectional key={activeRoofAssignmentTab} angle={activeRoofAssignmentTab} />
        )}
        <WindLoadCPEAreasMesh />
      </group>
    </>
  )
}

export default WindloadsScene
